export function thousandSeperator(x: number) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function fourDigitSeperator(x: number | string) {
    return x.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ' ');
}
